import { __assign, __awaiter, __generator } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@mui/material";
import { useMemo, useState } from "react";
import pickBy from "lodash/pickBy";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { FieldsForm, PangeaModal } from "@pangeacyber/react-mui-shared";
import { getUpdateFields } from "./fields";
import { useStoreFileViewerContext } from "../../hooks/context";
import { alertOnError } from "../AlertSnackbar/hooks";
export var UpdateAPIFields = new Set([
    "id",
    "name",
    "parent_id",
    "tags",
    "metadata",
]);
var UpdateFileButton = function (_a) {
    var object = _a.object, ButtonProps = _a.ButtonProps, onClose = _a.onClose;
    var _b = useStoreFileViewerContext(), apiRef = _b.apiRef, reload = _b.reload;
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var handleClose = function () {
        setOpen(false);
        onClose();
    };
    var fields = useMemo(function () {
        return getUpdateFields({ apiRef: apiRef });
    }, [apiRef]);
    var handleUpdate = function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!apiRef.update)
                return [2 /*return*/];
            setLoading(true);
            return [2 /*return*/, (apiRef
                    // @ts-ignore
                    .update(pickBy(body, function (v, k) { return UpdateAPIFields.has(k); }))
                    .then(function () {
                    handleClose();
                    setLoading(false);
                    reload();
                })
                    .catch(function (error) {
                    alertOnError(error);
                    setLoading(false);
                }))];
        });
    }); };
    if (!object.id)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ variant: "text", sx: { width: "100%" } }, ButtonProps, { startIcon: _jsx(EditOutlinedIcon, { fontSize: "small" }), onClick: function () { return setOpen(true); }, children: "Edit" })), _jsx(PangeaModal, { open: open, onClose: handleClose, title: "Edit", size: "small", children: _jsx(FieldsForm, { object: object, fields: fields, onCancel: handleClose, clearable: true, onSubmit: function (values) {
                        if (values.parent_id === "/") {
                            values.parent_id = "";
                        }
                        return handleUpdate(
                        // @ts-ignore
                        pickBy(values, function (v, k) { return !!v || k === "parent_id"; }));
                    }, disabled: loading }) })] }));
};
export default UpdateFileButton;
